import React from 'react';
import { Grid as DreiDrid, GridProps as DreiGridProps } from '@react-three/drei';

export type GridProps = DreiGridProps & {
  size?: number;
};

export const Grid: React.FC<GridProps> = ({ size = 100, ...restProps }) => {
  return (
    <DreiDrid
      args={[size, size]}
      fadeDistance={size}
      fadeStrength={1}
      infiniteGrid
      cellSize={1}
      sectionSize={10}
      sectionThickness={0.5}
      cellThickness={0.15}
      sectionColor={'#255c28'}
      cellColor={'#6f6f6f'}
      {...restProps}
    />
  );
};
